module.exports = __webpack_public_path__ + "img/price.235faac7.webp";